import { apiURL } from "./constants";
import axios from "axios";

/**
 * TODO(permissions #41): No frontend helper yet for
 * PUT /api/shipment/bulk-update/ (shipments_bulk_update).
 * Permission: PERMISSIONS.SHIPMENTS_BULK_UPDATE.
 * Current UI uses #47 (shipments_bulk_status_update) via `bulkUpdateShipments`
 * below, which hits /api/shipments/shipments_bulk_update/ instead. When a
 * dedicated #41 helper is introduced, gate the caller via
 * <PermissionGate /> or hasPermission().
 * See ENDPOINTS_USAGE.md Phase 7.
 */


//get shipments
export async function getShipments(shipmentOwner, ids, trackingNumber, shipperReference, status, location, paid, invoiced, type, payment_status, tags, page_size, page_index, transactionDateGte, transactionDateLte, shipmentUnit) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const tagsParam = tags != null && String(tags).trim() !== ""
        ? "&tags=" + encodeURIComponent(String(tags).trim())
        : "";
    const tdGte =
        transactionDateGte != null && String(transactionDateGte).trim() !== ""
            ? "&transaction_date__gte=" + encodeURIComponent(String(transactionDateGte).trim().slice(0, 10))
            : "";
    const tdLte =
        transactionDateLte != null && String(transactionDateLte).trim() !== ""
            ? "&transaction_date__lte=" + encodeURIComponent(String(transactionDateLte).trim().slice(0, 10))
            : "";
    // Selected unit object from the filter; omit the param when nothing is chosen.
    const shipmentUnitParam =
        shipmentUnit != null && shipmentUnit.id != null
            ? "&shipment_unit=" + encodeURIComponent(String(shipmentUnit.id))
            : "";
    const response = await axios.get(`${apiURL}/gofar/shipment/?owner__id=`
        + (shipmentOwner != null ? shipmentOwner.id : "")
        + "&deleted=false"
        + "&page=" + page_index
        + "&page_size=" + page_size
        + "&id=" + (ids != null ? ids.toString().replace(/[^\d\s]/g, '') : "")
        + "&tracking_number=" + (trackingNumber != null ? trackingNumber : "")
        + "&shipper_reference=" + (shipperReference != null ? shipperReference : "")
        + "&status=" + (status != null ? status : "")
        + "&location__id=" + (location != null ? location.id : "")
        + "&invoiced=" + (invoiced != null ? invoiced : "")
        + "&type=" + (type != null ? type : "")
        + "&payment_status=" + (payment_status != null ? payment_status : "")
        + tagsParam
        + tdGte
        + tdLte
        + shipmentUnitParam,
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    ).catch((error) => {
        console.error('There was an error!', error);
        throw error;
    });
    return response;
}

/**
 * List deleted (soft-deleted) shipments only.
 * GET /gofar/shipment/deleted/
 * Requires permission: shipments_deleted_list
 * Same query params and pagination as main list.
 */
export async function getDeletedShipments(shipmentOwner, ids, trackingNumber, shipperReference, status, location, invoiced, type, payment_status, tags, page_size, page_index, transactionDateGte, transactionDateLte, shipmentUnit) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const tagsParam = tags != null && String(tags).trim() !== ""
        ? "&tags=" + encodeURIComponent(String(tags).trim())
        : "";
    const tdGte =
        transactionDateGte != null && String(transactionDateGte).trim() !== ""
            ? "&transaction_date__gte=" + encodeURIComponent(String(transactionDateGte).trim().slice(0, 10))
            : "";
    const tdLte =
        transactionDateLte != null && String(transactionDateLte).trim() !== ""
            ? "&transaction_date__lte=" + encodeURIComponent(String(transactionDateLte).trim().slice(0, 10))
            : "";
    // Same unit id param as the active list, so deleted search stays in sync.
    const shipmentUnitParam =
        shipmentUnit != null && shipmentUnit.id != null
            ? "&shipment_unit=" + encodeURIComponent(String(shipmentUnit.id))
            : "";
    const response = await axios.get(
        `${apiURL}/gofar/shipment/deleted/`
        + "?page=" + page_index
        + "&page_size=" + page_size
        + "&owner__id=" + (shipmentOwner != null ? shipmentOwner.id : "")
        + "&id=" + (ids != null ? ids.toString().replace(/[^\d\s]/g, '') : "")
        + "&tracking_number=" + (trackingNumber != null ? trackingNumber : "")
        + "&shipper_reference=" + (shipperReference != null ? shipperReference : "")
        + "&status=" + (status != null ? status : "")
        + "&location__id=" + (location != null ? location.id : "")
        + "&invoiced=" + (invoiced != null ? invoiced : "")
        + "&type=" + (type != null ? type : "")
        + "&payment_status=" + (payment_status != null ? payment_status : "")
        + tagsParam
        + tdGte
        + tdLte
        + shipmentUnitParam,
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    ).catch((error) => {
        console.error('There was an error fetching deleted shipments!', error);
        throw error;
    });
    return response;
}

/**
 * Bulk soft-recover (undelete) shipments.
 * POST /gofar/shipment/recover/
 * Body: { ids: number[] }
 * Requires permission: shipments_recover
 * Returns: { recovered_count, recovered_ids, skipped_ids }
 */
export async function recoverShipments(ids) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.post(
        `${apiURL}/gofar/shipment/recover/`,
        { ids },
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    ).catch(error => {
        console.error('There was an error recovering shipments!', error);
        throw error;
    });
    return response;
}

//delete shipment throw api
//parameters
//ids: the ids of shipments you want to delete
export async function deleteShipments(ids) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.delete(`${apiURL}/api/shipment/bulk-delete/`, 
      {
        data: ids ,
        headers:
          { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    );
  
    return response;
  }


//this to allow posting file 
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

// Post shipments excel file through API (legacy one-step; prefer upload preview + confirm)
// Parameters
// data: the data of the file
export async function postShipmentsExcel(file) {

    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
        // Create FormData object and append file
        const formData = new FormData();
        formData.append('file', file);

        // Make POST request with Axios
        const response = await axios.post(`${apiURL}/api/shipments/upload/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true
        });

        return response;
    } catch (error) {
        console.error('There was an error!', error);
        throw error;
    }
}

/**
 * Step 1: Upload Excel and get preview (validation only, no DB write).
 * POST /api/shipments/upload/preview/
 * Returns { preview, errors, row_errors }.
 */
export async function postShipmentsUploadPreview(file) {
    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
        const formData = new FormData();
        formData.append('file', file);
        const response = await axios.post(`${apiURL}/api/shipments/upload/preview/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true,
        });
        return response;
    } catch (error) {
        console.error('postShipmentsUploadPreview error', error);
        throw error;
    }
}

/**
 * Step 2: Confirm and create shipments from preview data.
 * POST /api/shipments/upload/confirm/
 * Body: { shipments: [...] } (same shape as preview items).
 * Returns { detail, created_count, errors }.
 */
export async function postShipmentsUploadConfirm(shipments) {
    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
        const response = await axios.post(
            `${apiURL}/api/shipments/upload/confirm/`,
            { shipments },
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true,
            }
        );
        return response;
    } catch (error) {
        console.error('postShipmentsUploadConfirm error', error);
        throw error;
    }
}

/**
 * Download empty Excel template with correct column headers for shipment import.
 * GET /api/shipments/upload/template/
 * Returns binary Excel file. Caller should use response.data (blob) and trigger download.
 */
export async function getShipmentsUploadTemplate() {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/shipments/upload/template/`, {
        responseType: 'blob',
        withCredentials: true,
    });
    return response;
}

/**
 * Download sample Excel file with 5 dummy shipment rows for trying the import flow.
 * GET /api/shipments/upload/sample/
 * Returns binary Excel file. Caller should use response.data (blob) and trigger download.
 */
export async function getShipmentsUploadSample() {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/shipments/upload/sample/`, {
        responseType: 'blob',
        withCredentials: true,
    });
    return response;
}

//Get Shipment Types
export async function getShipmentTypes() {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/shipment_type/`,
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    ).catch((error) => {
        console.error('There was an error!', error);
        throw error;
    });
    return response;
}

//send whatsapp message for invoices 
export async function bulkSendShipmentsWhatsappMessage(shipments_ids) {

    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    // POST request using axios with error handling
    const response = await axios.post(`${apiURL}/api/bulk_send_shipments_whatsapp_message/`,
      {"shipments_ids" : shipments_ids},
      {
        headers:
          { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    )
      .catch((error) => {
        console.error('There was an error!', error);
        throw error;
      });
  
    return response;
  
  }


  //recalculate shipments price
export async function recalculateShipmentsPrice(shipments_ids) {

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // POST request using axios with error handling
  const response = await axios.post(`${apiURL}/api/shipments/recalculate_shipments_price/`,
    {"shipments_ids" : shipments_ids},
    {
      headers:
        { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  )
    .catch((error) => {
      console.error('There was an error!', error);
      throw error;
    });

  return response;

}

/**
 * POST /api/shipments/{id}/recalculate/
 * Permission: shipments_recalculate_price
 */
export async function recalculateSingleShipmentPrice(shipmentId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.post(
    `${apiURL}/api/shipments/${shipmentId}/recalculate/`,
    {},
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('recalculateSingleShipmentPrice error', error);
    throw error;
  });
  return response;
}

/**
 * GET /api/shipments/{id}/price/explain/
 * Permission: shipments_view
 */
export async function getShipmentPriceExplain(shipmentId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.get(
    `${apiURL}/api/shipments/${shipmentId}/price/explain/`,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('getShipmentPriceExplain error', error);
    throw error;
  });
  return response;
}

/**
 * GET /api/shipments/{id}/applied-rules/
 * Permission: shipments_applied_rules_manage
 */
export async function listShipmentAppliedRules(shipmentId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.get(
    `${apiURL}/api/shipments/${shipmentId}/applied-rules/`,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('listShipmentAppliedRules error', error);
    throw error;
  });
  return response;
}

/**
 * POST /api/shipments/{id}/applied-rules/
 * Permission: shipments_applied_rules_manage
 */
export async function postShipmentAppliedRule(shipmentId, body) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.post(
    `${apiURL}/api/shipments/${shipmentId}/applied-rules/`,
    body,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('postShipmentAppliedRule error', error);
    throw error;
  });
  return response;
}

/**
 * PATCH /api/shipments/{shipmentId}/applied-rules/{arId}/
 * Permission: shipments_applied_rules_manage
 */
export async function patchShipmentAppliedRule(shipmentId, arId, body) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.patch(
    `${apiURL}/api/shipments/${shipmentId}/applied-rules/${arId}/`,
    body,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('patchShipmentAppliedRule error', error);
    throw error;
  });
  return response;
}

/**
 * DELETE /api/shipments/{shipmentId}/applied-rules/{arId}/
 * Permission: shipments_applied_rules_manage
 */
export async function deleteShipmentAppliedRule(shipmentId, arId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.delete(
    `${apiURL}/api/shipments/${shipmentId}/applied-rules/${arId}/`,
    { withCredentials: true }
  ).catch((error) => {
    console.error('deleteShipmentAppliedRule error', error);
    throw error;
  });
  return response;
}


// Bulk update shipments and send messages.
// Optional body fields: description, create_tracking_event, tracking_event_timestamp.
export async function bulkUpdateShipments(data) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.put(`${apiURL}/api/shipments/shipments_bulk_update/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  }).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });
  return response;
}

/**
 * Bulk add, replace, or remove shipment tags on many rows.
 * POST /api/shipment/bulk-tags/
 * Body: { shipment_ids: number[], action: 'add'|'replace'|'remove', tags: string[] }
 * Permission: shipments_bulk_tags.
 */
export async function bulkShipmentTags(payload) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.post(
    `${apiURL}/api/shipment/bulk-tags/`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('bulkShipmentTags error', error);
    throw error;
  });
  return response;
}




/**
 * Scan update: PUT shipment/<id>/scan_update/
 * Body: { location?, status?, event_type?, send_whatsapp?, client_event_id? }.
 * The helper auto-fills `client_event_id` (UUID v4) so retries dedupe per
 * (shipment, cid). Response includes a new `idempotent_replay` boolean — true
 * when the same client_event_id was already applied. See
 * FRONTEND_INTEGRATION_GUIDE §4 (Idempotent scan-update contract).
 */
export async function scanUpdateShipment(shipmentId, body) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  let payload = body || {};
  if (!payload.client_event_id) {
    try {
      // Prefer the shared UUID helper from the pieces module so both flows
      // share the same idempotency contract; fall back to a local UUID if the
      // import is unavailable (defensive).
      // eslint-disable-next-line global-require
      const { newClientEventId } = require('./shipmentPiece');
      payload = { ...payload, client_event_id: newClientEventId() };
    } catch (_) {
      // Minimal v4 fallback if the helper isn't loadable for any reason.
      const hex = () => Math.floor(Math.random() * 0xffffffff).toString(16).padStart(8, '0');
      payload = { ...payload, client_event_id: `${hex()}-${hex().slice(0, 4)}-4${hex().slice(1, 4)}-${(8 + Math.floor(Math.random() * 4)).toString(16)}${hex().slice(1, 4)}-${hex()}${hex().slice(0, 4)}` };
    }
  }
  const response = await axios.put(
    `${apiURL}/api/shipment/${shipmentId}/scan_update/`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  );
  return response;
}

//receive shipments
export async function receiveShipmentsRequest(data) {

  const payload = JSON.stringify(data)

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // POST request using axios with error handling
  const response = await axios.put(`${apiURL}/api/shipments/receive_shipments/`, payload,
    {
      headers:
        { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  ).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });
  console.log(response);

  return response;
}

/**
 * Create a shipment (optionally with nested `pieces[]` in one request).
 * POST /api/shipment/ — Permission: shipments_create
 *
 * When `pieces` is non-empty, `packages_quantity` on the payload is ignored
 * by the server and totals are rolled up from the pieces.
 */
export async function createShipment(data) {
  axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.post(`${apiURL}/api/shipment/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
  return response;
}

/**
 * Fetch a single shipment by id (customer or staff).
 * GET /gofar/shipment/<id>/
 *
 * Response includes the new `pieces` array and `pieces_status_summary` fields
 * — see FRONTEND_INTEGRATION_GUIDE §10.1. Customers need the
 * `shipment_pieces_customer_view` / `shipment_pieces_customer_list_for_shipment`
 * permissions assigned to their role for the nested data to appear.
 */
export async function getShipmentById(shipmentId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.get(
    `${apiURL}/gofar/shipment/${shipmentId}/`,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
  return response;
}

/**
 * Customer app: get tracking events for a shipment (customer must own the shipment).
 * GET /api/customer/shipment/<shipment_id>/tracking-events/
 * Returns {
 *   tracking_events,
 *   expected_destination_eta,
 *   expected_warehouse_eta,
 *   pieces_status_summary,
 * }.
 * tracking_events is newest first. ETA fields are YYYY-MM-DD or null.
 */
export async function getCustomerShipmentTrackingEvents(shipmentId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.get(
    `${apiURL}/api/customer/shipment/${shipmentId}/tracking-events/`,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('getCustomerShipmentTrackingEvents error', error);
    throw error;
  });
  return response;
}